import { styled, keyframes } from 'styled-components';

export const WrapperMain = styled.div`
  width: 100vw;
  height: 100vh;
  padding: 26px;
  gap: 3px;
  text-align: center;
  background: #131315;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
`;
export const WrapperItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 26px;
  text-align: center;
  background: #131315;
`;

const rotateAnimation = keyframes`
 0% { transform: rotate(0); }
 50% { transform: rotate(90deg); } 
 99% { transform: rotate(90deg); }  
 100% { transform: rotate(0); }       
`;

export const AnimatedPhoneIcon = styled.img`
  transform-origin: center;
  animation: ${rotateAnimation} 3s infinite;
  will-change: transform;
`;
